import * as React from "react";
import * as ReactDom from "react-dom";
import { ErrorBoundary } from "./ErrorBoundary";

export const renderReactComponent: ReactDom.Renderer = (element: any, ...args: any[]) => {
    const wrappedElement = React.createElement(ErrorBoundary, null, element);
    // eslint-disable-next-line no-restricted-syntax
    return ReactDom.render(wrappedElement, ...(args as [any, any])) as any;
};
